import { css } from 'styled-components';
import { getEnv } from 'utils';

const CDN_PUBLIC_ASSETS_URL = getEnv('CDN_PUBLIC_ASSETS_URL');

export default css`
  .sprite-wrapper-20 {
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .sprite-icon {
    background-repeat: no-repeat;
    display: block;
    flex-shrink: 0;
  }

  /* Workspace header - top bar (black theme) */
  .sprite-top-black-download-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-top.png');
    width: 40px;
    height: 32px;
    background-position: -5px -5px;
    transform: scale(0.6);
    transform-origin: center center;
  }

  .sprite-top-black-help-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-top.png');
    width: 40px;
    height: 40px;
    background-position: -55px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-top-black-presentation-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-top.png');
    width: 40px;
    height: 40px;
    background-position: -5px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-top-black-saved-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-top.png');
    width: 50px;
    height: 30px;
    background-position: -105px -5px;
    transform: scale(0.7);
    transform-origin: center center;
    margin-right: 12px;
  }

  .sprite-top-black-share-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-top.png');
    width: 28px;
    height: 30px;
    background-position: -105px -45px;
    transform: scale(0.666);
    transform-origin: center center;
  }

  /* Workspace header - top bar (pink theme) */
  .sprite-top-pink-download-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-top.png');
    width: 40px;
    height: 32px;
    background-position: -5px -5px;
    transform: scale(0.6);
    transform-origin: center center;
  }

  .sprite-top-pink-help-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-top.png');
    width: 40px;
    height: 40px;
    background-position: -5px -47px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-top-pink-presentation-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-top.png');
    width: 40px;
    height: 40px;
    background-position: -55px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-top-pink-share-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-top.png');
    width: 28px;
    height: 30px;
    background-position: -105px -5px;
    transform: scale(0.666);
    transform-origin: center center;
  }

  /* Workspace left menu - black theme */
  .sprite-workspace-black-backgrounds-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 49px;
    height: 50px;
    background-position: -5px -5px;
    transform: scale(0.4);
    transform-origin: center center;
  }

  .sprite-workspace-black-charts-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 46px;
    height: 46px;
    background-position: -64px -5px;
    transform: scale(0.435);
    transform-origin: center center;
  }

  .sprite-workspace-black-generative-ai-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 40px;
    height: 40px;
    background-position: -120px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-black-heart-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 48px;
    height: 52px;
    background-position: -64px -61px;
    transform: scale(0.417);
    transform-origin: center center;
  }

  .sprite-workspace-black-icon-request-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 49px;
    height: 65px;
    background-position: -170px -5px;
    transform: scale(0.308);
    transform-origin: center center;
  }

  .sprite-workspace-black-shapes-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 51px;
    height: 49px;
    background-position: -122px -80px;
    transform: scale(0.351);
    transform-origin: center center;
  }

  .sprite-workspace-black-templates-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 57px;
    height: 41px;
    background-position: -5px -137px;
    transform: scale(0.351);
    transform-origin: center center;
  }

  .sprite-workspace-black-text-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 38px;
    height: 37px;
    background-position: -5px -80px;
    transform: scale(0.526);
    transform-origin: center center;
  }

  .sprite-workspace-black-uploads-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-left.png');
    width: 40px;
    height: 40px;
    background-position: -183px -80px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  /* Workspace left menu - pink theme */
  .sprite-workspace-pink-backgrounds-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 40px;
    height: 40px;
    background-position: -5px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-pink-charts-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 40px;
    height: 40px;
    background-position: -55px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-pink-generative-ai-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 40px;
    height: 40px;
    background-position: -105px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-pink-heart-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 47px;
    height: 49px;
    background-position: -5px -55px;
    transform: scale(0.4, 0.45);
    transform-origin: center center;
  }

  .sprite-workspace-pink-icon-request-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 49px;
    height: 65px;
    background-position: -63px -55px;
    transform: scale(0.308);
    transform-origin: center center;
  }

  .sprite-workspace-pink-shapes-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 40px;
    height: 38px;
    background-position: -155px -5px;
    transform: scale(0.45);
    transform-origin: center center;
  }

  .sprite-workspace-pink-templates-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 43px;
    height: 30px;
    background-position: -155px -53px;
    transform: scale(0.47, 0.48);
    transform-origin: center center;
  }

  .sprite-workspace-pink-text-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 40px;
    height: 40px;
    background-position: -122px -93px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-pink-uploads-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-left.png');
    width: 40px;
    height: 40px;
    background-position: -5px -143px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  /* Workspace right menu - black theme */
  .sprite-workspace-black-backups-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-right.png');
    width: 48px;
    height: 48px;
    background-position: -5px -5px;
    transform: scale(0.417);
    transform-origin: center center;
  }

  .sprite-workspace-black-comments-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-right.png');
    width: 40px;
    height: 36px;
    background-position: -63px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-black-custom-services-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-right.png');
    width: 48px;
    height: 64px;
    background-position: -63px -51px;
    transform: scale(0.313);
    transform-origin: center center;
  }

  .sprite-workspace-black-settings-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-right.png');
    width: 48px;
    height: 51px;
    background-position: -121px -5px;
    transform: scale(0.392);
    transform-origin: center center;
  }

  .sprite-workspace-black-slides-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-right.png');
    width: 66px;
    height: 50px;
    background-position: -121px -66px;
    transform: scale(0.303);
    transform-origin: center center;
  }

  /* Workspace right menu - pink theme */
  .sprite-workspace-pink-backups-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-right.png');
    width: 40px;
    height: 40px;
    background-position: -5px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-pink-comments-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-right.png');
    width: 40px;
    height: 36px;
    background-position: -55px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-pink-custom-services-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-right.png');
    width: 48px;
    height: 64px;
    background-position: -105px -5px;
    transform: scale(0.313);
    transform-origin: center center;
  }

  .sprite-workspace-pink-settings-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-right.png');
    width: 38px;
    height: 40px;
    background-position: -5px -79px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-workspace-pink-slides-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-pink-right.png');
    width: 40px;
    height: 30px;
    background-position: -53px -79px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  /* Toolbar bottom controls (undo/redo/zoom) */
  .sprite-toolbar-bottom-redo-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-bottom.png');
    width: 36px;
    height: 34px;
    background-position: -5px -5px;
    transform: scale(0.456);
    transform-origin: center center;
  }

  .sprite-toolbar-bottom-undo-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-bottom.png');
    width: 36px;
    height: 34px;
    background-position: -51px -5px;
    transform: scale(0.456);
    transform-origin: center center;
  }

  .sprite-toolbar-bottom-zoom-decrease-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-bottom.png');
    width: 18px;
    height: 4px;
    background-position: -97px -5px;
    transform: scale(0.6);
    transform-origin: center center;
  }

  .sprite-toolbar-bottom-zoom-increase-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-bottom.png');
    width: 18px;
    height: 16px;
    background-position: -97px -19px;
    transform: scale(0.6);
    transform-origin: center center;
  }

  .sprite-toolbar-bottom-zoom-reset-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-bottom.png');
    width: 30px;
    height: 28px;
    background-position: -5px -49px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  /* Toolbar main actions (subset from toolbar-one spritesheet) */
  .sprite-toolbar-one-bring-forward-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 42px;
    height: 38px;
    background-position: -5px -5px;
    transform: scale(0.476);
    transform-origin: center center;
  }

  .sprite-toolbar-one-bring-to-front-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 42px;
    height: 50px;
    background-position: -57px -5px;
    transform: scale(0.4);
    transform-origin: center center;
  }

  .sprite-toolbar-one-fill-color-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 40px;
    height: 38px;
    background-position: -109px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-toolbar-one-fit-to-canvas-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 40px;
    height: 40px;
    background-position: -5px -53px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-toolbar-one-flip-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 48px;
    height: 40px;
    background-position: -109px -53px;
    transform: scale(0.417);
    transform-origin: center center;
  }

  .sprite-toolbar-one-lock-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 30px;
    height: 40px;
    background-position: -5px -103px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-toolbar-one-opacity-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 36px;
    height: 42px;
    background-position: -45px -103px;
    transform: scale(0.476);
    transform-origin: center center;
  }

  .sprite-toolbar-one-remove-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 34px;
    height: 40px;
    background-position: -91px -103px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-toolbar-one-send-backward-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 42px;
    height: 40px;
    background-position: -167px -5px;
    transform: scale(0.476);
    transform-origin: center center;
  }

  .sprite-toolbar-one-send-to-back-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 42px;
    height: 50px;
    background-position: -167px -55px;
    transform: scale(0.4);
    transform-origin: center center;
  }

  .sprite-toolbar-one-stroke-edit-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-one.png');
    width: 48px;
    height: 34px;
    background-position: -135px -115px;
    transform: scale(0.417);
    transform-origin: center center;
  }

  /* Toolbar icons - main spritesheet (spritesheet-toolbar-all.png) */
  .sprite-align-bottom-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 34px;
    height: 32px;
    background-position: -5px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-align-center-horizontal-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 26px;
    height: 32px;
    background-position: -49px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-align-center-vertical-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 34px;
    height: 26px;
    background-position: -85px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-align-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 42px;
    height: 40px;
    background-position: -129px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-align-left-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 34px;
    height: 32px;
    background-position: -181px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-align-right-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 34px;
    height: 32px;
    background-position: -225px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-align-top-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 34px;
    height: 32px;
    background-position: -269px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-bring-forward-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 42px;
    height: 38px;
    background-position: -313px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-bring-to-front-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 42px;
    height: 50px;
    background-position: -365px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-bullet-list-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 36px;
    height: 40px;
    background-position: -5px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-change-case-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 52px;
    height: 32px;
    background-position: -5px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-chart-edition-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 44px;
    height: 42px;
    background-position: -67px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-convert-to-curve-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 44px;
    height: 44px;
    background-position: -121px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-convert-to-line-icon-dark {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 44px;
    height: 44px;
    background-position: -175px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-crop-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 48px;
    height: 44px;
    background-position: -229px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-crop-square-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 42px;
    height: 42px;
    background-position: -287px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-dashed-border-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 268px;
    height: 6px;
    background-position: -5px -109px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-dotted-border-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 268px;
    height: 6px;
    background-position: -5px -125px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-drag-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 12px;
    height: 58px;
    background-position: -339px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-edit-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 48px;
    height: 48px;
    background-position: -5px -55px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-effects-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 50px;
    height: 52px;
    background-position: -361px -113px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-favorite-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 46px;
    height: 44px;
    background-position: -283px -113px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-favorite-icon-active {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 46px;
    height: 44px;
    background-position: -421px -113px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-fill-color-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 42px;
    height: 40px;
    background-position: -5px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-fit-to-canvas-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 40px;
    height: 40px;
    background-position: -57px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-flip-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 48px;
    height: 40px;
    background-position: -107px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-group-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 48px;
    height: 48px;
    background-position: -165px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-regroup-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 40px;
    height: 40px;
    background-position: -225px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-image-edition-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 44px;
    height: 42px;
    background-position: -223px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-left-pointer-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 36px;
    height: 26px;
    background-position: -277px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-line-spacing-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 44px;
    height: 42px;
    background-position: -421px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-lock-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 32px;
    height: 40px;
    background-position: -5px -219px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-normal-list-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 34px;
    height: 34px;
    background-position: -47px -219px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-numered-list-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 36px;
    height: 44px;
    background-position: -91px -219px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-opacity-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 36px;
    height: 42px;
    background-position: -223px -219px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-pointer-option-1-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 30px;
    height: 20px;
    background-position: -269px -219px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-pointer-option-2-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 30px;
    height: 22px;
    background-position: -309px -219px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-pointer-option-3-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 34px;
    height: 20px;
    background-position: -349px -219px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-pointer-option-4-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 36px;
    height: 24px;
    background-position: -393px -219px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-pointer-option-5-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 38px;
    height: 22px;
    background-position: -137px -253px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-power-edit-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 176px;
    height: 36px;
    background-position: -269px -253px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-remove-bg-black-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 128px;
    height: 18px;
    background-position: -5px -299px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-remove-bg-white-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 128px;
    height: 18px;
    background-position: -143px -299px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-remove-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 36px;
    height: 40px;
    background-position: -281px -299px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-right-pointer-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 36px;
    height: 26px;
    background-position: -327px -299px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-send-backward-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 42px;
    height: 40px;
    background-position: -373px -299px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-send-to-back-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 42px;
    height: 50px;
    background-position: -425px -299px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-solid-border-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 268px;
    height: 6px;
    background-position: -5px -141px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-stroke-color-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 42px;
    height: 38px;
    background-position: -5px -359px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-stroke-edit-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 48px;
    height: 34px;
    background-position: -57px -359px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-align-center-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 46px;
    height: 34px;
    background-position: -115px -359px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-align-justify-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 46px;
    height: 34px;
    background-position: -171px -359px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-align-left-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 46px;
    height: 34px;
    background-position: -227px -359px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-align-right-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 46px;
    height: 34px;
    background-position: -283px -359px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-bold-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 24px;
    height: 32px;
    background-position: -323px -167px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-effect-none-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 158px;
    height: 156px;
    background-position: -477px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-effect-outline-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 156px;
    height: 156px;
    background-position: -477px -171px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-effect-shadow-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-toolbar-all.png');
    width: 156px;
    height: 156px;
    background-position: -477px -337px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  /* Text toolbar icons (italic, subscript, superscript, underline) */
  .sprite-text-italic-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-text-toolbar.png');
    width: 30px;
    height: 32px;
    background-position: -5px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-subscript-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-text-toolbar.png');
    width: 30px;
    height: 32px;
    background-position: -45px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-superscript-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-text-toolbar.png');
    width: 32px;
    height: 34px;
    background-position: -85px -5px;
    transform: scale(0.5);
    transform-origin: center center;
  }

  .sprite-text-underline-icon {
    background-image: url('${CDN_PUBLIC_ASSETS_URL}/spritesheet-text-toolbar.png');
    width: 28px;
    height: 34px;
    background-position: -5px -49px;
    transform: scale(0.5);
    transform-origin: center center;
  }
`;
